import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// USED THERE
// src/overrides/peregrine/store/reducers/bookTable.js

import { actionTypesSimple } from "./BookTable.actionTypes";
export const defaultStoreCity = {
  cities: [],
  storesFullData: [],
  selectedStore: null,
  previousBookings: [],
  favRestaurant: null,
  previousValues: null,
  modalOpen: false,
  modalFeedbackOpen: false,
  isThisEditFlow: false,
  isFavRestaurantSelected: false,
  cancelBookingError: null
};
const setCity = (state, _ref) => {
  let {
    payload: cities
  } = _ref;
  return _objectSpread(_objectSpread({}, state), {}, {
    cities
  });
};
const setStores = (state, _ref2) => {
  let {
    payload: storesFullData
  } = _ref2;
  return _objectSpread(_objectSpread({}, state), {}, {
    storesFullData
  });
};
const setSelectedStore = (state, _ref3) => {
  let {
    payload: selectedStore
  } = _ref3;
  return _objectSpread(_objectSpread({}, state), {}, {
    selectedStore
  });
};
const setPreviousBookings = (state, _ref4) => {
  let {
    payload: previousBookings
  } = _ref4;
  return _objectSpread(_objectSpread({}, state), {}, {
    previousBookings
  });
};
const setFavRestaurant = (state, _ref5) => {
  let {
    payload: favRestaurant
  } = _ref5;
  return _objectSpread(_objectSpread({}, state), {}, {
    favRestaurant
  });
};
const setContactId = (state, _ref6) => {
  let {
    payload: contactId
  } = _ref6;
  return _objectSpread(_objectSpread({}, state), {}, {
    contactId
  });
};
const setPreviousValues = (state, _ref7) => {
  let {
    payload: previousValues
  } = _ref7;
  return _objectSpread(_objectSpread({}, state), {}, {
    previousValues
  });
};
const setModalOpen = (state, _ref8) => {
  let {
    payload: modalOpen
  } = _ref8;
  return _objectSpread(_objectSpread({}, state), {}, {
    modalOpen
  });
};
const setModalFeedbackOpen = (state, _ref9) => {
  let {
    payload: modalFeedbackOpen
  } = _ref9;
  return _objectSpread(_objectSpread({}, state), {}, {
    modalFeedbackOpen
  });
};
const setIsEditFlow = (state, _ref0) => {
  let {
    payload: isThisEditFlow
  } = _ref0;
  return _objectSpread(_objectSpread({}, state), {}, {
    isThisEditFlow: !!isThisEditFlow
  });
};
const setFavRestaurantSelected = (state, _ref1) => {
  let {
    payload: isFavRestaurantSelected
  } = _ref1;
  return _objectSpread(_objectSpread({}, state), {}, {
    isFavRestaurantSelected: !!isFavRestaurantSelected
  });
};
const setCancelBookingError = (state, _ref10) => {
  let {
    payload: cancelBookingError
  } = _ref10;
  return _objectSpread(_objectSpread({}, state), {}, {
    cancelBookingError
  });
};
const resetBook_a_table = (state, payload) => {
  return _objectSpread({}, defaultStoreCity);
};
export const setCityReducerObject = {
  [actionTypesSimple.SET_CITIES]: setCity,
  [actionTypesSimple.SET_STORES_FULL]: setStores,
  [actionTypesSimple.SET_SELECTED_STORE]: setSelectedStore,
  [actionTypesSimple.SET_PREVIOUS_BOOKINGS]: setPreviousBookings,
  [actionTypesSimple.SET_FAV_RESTAURANT]: setFavRestaurant,
  [actionTypesSimple.SET_CONTACT_ID]: setContactId,
  [actionTypesSimple.SET_PREVIOUS_VALUES]: setPreviousValues,
  [actionTypesSimple.SET_MODAL_OPEN]: setModalOpen,
  [actionTypesSimple.SET_MODAL_FEEDBACK_OPEN]: setModalFeedbackOpen,
  [actionTypesSimple.SET_IS_EDIT_FLOW]: setIsEditFlow,
  [actionTypesSimple.SET_FAV_RESTAURANT_SELECTED]: setFavRestaurantSelected,
  [actionTypesSimple.SET_CANCEL_BOOKING_ERROR]: setCancelBookingError,
  [actionTypesSimple.RESET_BOOK_A_TABLE]: resetBook_a_table
};